module.exports = __webpack_public_path__ + "static/media/lightening_series.3904f2a9.jpg";